import { IconButton, Tooltip } from "@chakra-ui/react";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

// Single chevron toggle for the drill-down tables with roll-down rows, meant
// to sit next to the table title. Down chevron = "Expand all" (rows are
// collapsed); up chevron = "Collapse all" (all rows open). A tooltip names
// the action on hover. Disabled/hidden by the caller when there's nothing to
// expand.
//
// Props: allExpanded boolean + onExpandAll / onCollapseAll. When everything is
// already open the chevron flips to "up" and collapses; otherwise it expands.
const ExpandCollapseControl = ({ allExpanded, onExpandAll, onCollapseAll }) => {
  const label = allExpanded ? "Collapse all" : "Expand all";
  return (
    <Tooltip label={label} placement="top" hasArrow openDelay={300}>
      <IconButton
        aria-label={label}
        icon={allExpanded ? <CaretUp size={14} weight="bold" /> : <CaretDown size={14} weight="bold" />}
        size="xs"
        variant="ghost"
        color="gray.500"
        borderRadius="full"
        _hover={{ bg: "gray.100", color: "darkTeal" }}
        onClick={allExpanded ? onCollapseAll : onExpandAll}
      />
    </Tooltip>
  );
};

export default ExpandCollapseControl;
